import { GeometryType } from '../enums/geometry-type.enum';

export interface IGeometry {
  type: GeometryType;
  coordinates: string[];
}
